interface CityCoord {
  lat: number;
  lng: number;
  state?: string;
}

const INDIAN_CITIES: Record<string, CityCoord> = {
  mumbai: { lat: 19.076, lng: 72.8777, state: 'Maharashtra' },
  delhi: { lat: 28.6139, lng: 77.209, state: 'Delhi' },
  'new delhi': { lat: 28.6139, lng: 77.209, state: 'Delhi' },
  bangalore: { lat: 12.9716, lng: 77.5946, state: 'Karnataka' },
  bengaluru: { lat: 12.9716, lng: 77.5946, state: 'Karnataka' },
  hyderabad: { lat: 17.385, lng: 78.4867, state: 'Telangana' },
  chennai: { lat: 13.0827, lng: 80.2707, state: 'Tamil Nadu' },
  kolkata: { lat: 22.5726, lng: 88.3639, state: 'West Bengal' },
  pune: { lat: 18.5204, lng: 73.8567, state: 'Maharashtra' },
  ahmedabad: { lat: 23.0225, lng: 72.5714, state: 'Gujarat' },
  jaipur: { lat: 26.9124, lng: 75.7873, state: 'Rajasthan' },
  lucknow: { lat: 26.8467, lng: 80.9462, state: 'Uttar Pradesh' },
  kanpur: { lat: 26.4499, lng: 80.3319, state: 'Uttar Pradesh' },
  nagpur: { lat: 21.1458, lng: 79.0882, state: 'Maharashtra' },
  indore: { lat: 22.7196, lng: 75.8577, state: 'Madhya Pradesh' },
  bhopal: { lat: 23.2599, lng: 77.4126, state: 'Madhya Pradesh' },
  visakhapatnam: { lat: 17.6868, lng: 83.2185, state: 'Andhra Pradesh' },
  patna: { lat: 25.5941, lng: 85.1376, state: 'Bihar' },
  vadodara: { lat: 22.3072, lng: 73.1812, state: 'Gujarat' },
  ghaziabad: { lat: 28.6692, lng: 77.4538, state: 'Uttar Pradesh' },
  ludhiana: { lat: 30.901, lng: 75.8573, state: 'Punjab' },
  agra: { lat: 27.1767, lng: 78.0081, state: 'Uttar Pradesh' },
  nashik: { lat: 19.9975, lng: 73.7898, state: 'Maharashtra' },
  faridabad: { lat: 28.4089, lng: 77.3178, state: 'Haryana' },
  meerut: { lat: 28.9845, lng: 77.7064, state: 'Uttar Pradesh' },
  rajkot: { lat: 22.3039, lng: 70.8022, state: 'Gujarat' },
  varanasi: { lat: 25.3176, lng: 82.9739, state: 'Uttar Pradesh' },
  srinagar: { lat: 34.0837, lng: 74.7973, state: 'Jammu and Kashmir' },
  amritsar: { lat: 31.634, lng: 74.8723, state: 'Punjab' },
  chandigarh: { lat: 30.7333, lng: 76.7794, state: 'Chandigarh' },
  kochi: { lat: 9.9312, lng: 76.2673, state: 'Kerala' },
  coimbatore: { lat: 11.0168, lng: 76.9558, state: 'Tamil Nadu' },
  guwahati: { lat: 26.1445, lng: 91.7362, state: 'Assam' },
  dehradun: { lat: 30.3165, lng: 78.0322, state: 'Uttarakhand' },
  surat: { lat: 21.1702, lng: 72.8311, state: 'Gujarat' },
  thane: { lat: 19.2183, lng: 72.9781, state: 'Maharashtra' },
  jodhpur: { lat: 26.2389, lng: 73.0243, state: 'Rajasthan' },
  udaipur: { lat: 24.5854, lng: 73.7125, state: 'Rajasthan' },
  kota: { lat: 25.2138, lng: 75.8648, state: 'Rajasthan' },
  ajmer: { lat: 26.4499, lng: 74.6399, state: 'Rajasthan' },
};

const INDIAN_STATES: Record<string, CityCoord> = {
  rajasthan: { lat: 27.0238, lng: 74.2179 },
  maharashtra: { lat: 19.7515, lng: 75.7139 },
  karnataka: { lat: 15.3173, lng: 75.7139 },
  'uttar pradesh': { lat: 26.8467, lng: 80.9462 },
  gujarat: { lat: 22.2587, lng: 71.1924 },
  delhi: { lat: 28.6139, lng: 77.209 },
  'tamil nadu': { lat: 11.1271, lng: 78.6569 },
  'west bengal': { lat: 22.9868, lng: 87.855 },
  telangana: { lat: 18.1124, lng: 79.0193 },
  kerala: { lat: 10.8505, lng: 76.2711 },
  punjab: { lat: 31.1471, lng: 75.3412 },
  haryana: { lat: 29.0588, lng: 76.0856 },
  'madhya pradesh': { lat: 22.9734, lng: 78.6569 },
  bihar: { lat: 25.0961, lng: 85.3131 },
  odisha: { lat: 20.9517, lng: 85.0985 },
  assam: { lat: 26.2006, lng: 92.9376 },
};

function normalizeKey(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

export function resolveIndiaCoords(city: string, state = ''): { lat: number; lng: number } | null {
  const cityKey = normalizeKey(city);
  const stateKey = normalizeKey(state);

  if (cityKey && INDIAN_CITIES[cityKey]) {
    return { lat: INDIAN_CITIES[cityKey].lat, lng: INDIAN_CITIES[cityKey].lng };
  }

  if (stateKey && INDIAN_STATES[stateKey]) {
    return { lat: INDIAN_STATES[stateKey].lat, lng: INDIAN_STATES[stateKey].lng };
  }

  const partialCity = Object.entries(INDIAN_CITIES).find(([key]) =>
    cityKey.includes(key) || key.includes(cityKey),
  );
  if (partialCity) {
    return { lat: partialCity[1].lat, lng: partialCity[1].lng };
  }

  return null;
}
